import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Route, Switch, Redirect } from "react-router-dom";
import agent from '../agent'
import Modal from 'react-responsive-modal';

import PublicRegistrationDescription from '../components/PublicRegistrationDescription';
import PublicRegistrationRequirements from '../components/PublicRegistrationRequirements';
import ImDb from '../components/ImDb';
import Aux from './AuxContainer'
import AMLogo from '../assets/images/audition-magic-favicon.png';
import Back from '../components/Back'
import Background from '../assets/images/stock1.jpg'
import Loading from '../assets/images/AuditionMagic_50x50_GIF_0.1sec.gif'



const headerSytle = {
	testTransform: 'uppercase',
	color: '#008DEF',
	fontFamily: 'ITCAvantGardeStd-Book',
	fontSize: '28px'
}


const Header = ({companyLogo}) => (
	<section id="brand-logo" className="section-brand-logo public-header section">
	  <div className="row">
	  <div className="small-12 small-centered column text-center">
	  	<div className="header-image-container">
	  		<img className="company-logo" src={companyLogo} alt=""/>
	  	</div>
	  	<div className="post-relative with-name">
	  		<h3 style={headerSytle}>Audition Opportunity</h3>
	    </div>
	  </div>
	  </div>
	</section>
)

class PublicRegistrationPage extends Component {
	state = {
		loading: true
	}

	componentWillMount() {
		const { location, history } = this.props
		const token = new URLSearchParams(location.search).get('token');

		if (!token) {
			history.push('/')	
		} else {

			const project = agent.Project.projectById(token)
			const company = project.then( ({project}) => agent.My.info(project.company_token) )
			this.props.onLoad(
				Promise.all([
					project,
					company
				])
			)
			console.log('componentWillMount', token, project, company)
		}
	}

	render() {
		const { project, company, match } = this.props
		const imdb = new URLSearchParams(this.props.location.search).get('imdb')
		if (!project || !company || !this.state.loading) {
			return (
				<div className="row stand-up">
					<div className="column large-3 large-centered text-center"><span>Loading project details...</span></div>
					<div className="column large-3 large-centered text-center"><img src={Loading}width={100}  /></div>
				</div>
			)
		}

		return(
			<Aux>
				{ imdb && (<ImDb />) }
				<Header companyLogo={company.logo_url} />
				<Switch>
						<Route path={`${match.path}`} exact component={PublicRegistrationDescription} />
	 					<Route path={`${match.path}/roles_selection`} exact component={PublicRegistrationRequirements} />
	 					<Redirect to={`${match.url}`} />
	 			</Switch>
			</Aux>
		)
	}
	
	
}

const mapStateToProps = state => ({
	project: state.projects.project,
	company: state.projects.company
	// project: state.projects.project[0],
	// company: state.company.details[1]
})

const mapDispatchToProps = dispatch => ({
	onLoad: payload =>
		dispatch({ type: `PUBLIC_REGISTRATION_PAGE`, payload: payload })

	// getProject: id => 
	// 	dispatch({
	// 		type: 'PUBLIC_PROJECT_DETAILS', 
	// 		// payload: agent.Project.viaToken(id)
	// 		payload: agent.Project.projectById(id)
	// 	}),
	// getCompany: id =>
	// 	dispatch({ type: 'GET_COMPANY', payload: agent.My.info(id) })
})

export default connect(mapStateToProps, mapDispatchToProps)(PublicRegistrationPage)





// WEBPACK FOOTER //
// ./src/containers/PublicRegistrationPage.js